import { createContext, useEffect, useReducer } from "react";
import DarkModeReducer from "./darkModeReducer";

const STORAGE_KEY = "wg:theme";

/** Resolve the initial mode: explicit choice first, OS preference second. */
const readInitialMode = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "dark") return true;
    if (stored === "light") return false;
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  } catch {
    return false;
  }
};

const INITIAL_STATE = { darkMode: readInitialMode() };

export const DarkModeContext = createContext(INITIAL_STATE);

export const DarkModeContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(DarkModeReducer, INITIAL_STATE);

  // Stamp the choice on <html> so portalled UI (dialogs, menus, tooltips)
  // resolves the same tokens as the page, and persist it across sessions.
  useEffect(() => {
    const mode = state.darkMode ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", mode);
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      /* storage unavailable — the attribute is still applied */
    }
  }, [state.darkMode]);

  return (
    <DarkModeContext.Provider value={{ darkMode: state.darkMode, dispatch }}>
      {children}
    </DarkModeContext.Provider>
  );
};
